export const providerMap = new Map([
  ['facebook', 'facebook'],
  ['google', 'google-oauth2'],
  ['vkontakte', 'vk-oauth2'],
  ['apple', 'apple-id']
]);
